import { getAgsApiUrl, smb_fetch } from '@/api/operator/fetch';

const callCenterConfigList =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/call-center', 'get-operator-line-rule');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
};


const callCenterConfigUpdate =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/call-center', 'update-operator-line-rule');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
};

const checkLineMatch = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/call-center', 'check-operator-line');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
};

export default {
  callCenterConfigUpdate,
  callCenterConfigList,
  checkLineMatch,
};
